
const helpers = {
  isMobile() {
    return window.innerWidth <= 768;
  },
  getTimestamp() {
    return Math.floor(Date.now() / 1000);
  },
  sendNotification() {
    const title = 'My Title';
    const options = {
      icon: require('./assets/images/message.png'),
      body: 'Hello from my Website!',
    };
    const n = new Notification(title, options);

    setTimeout(n.close.bind(n), 10000);
  },
  popUpNote() {
    if ('Notification' in window) {
      if (Notification.permission === 'default') {
        Notification.requestPermission()
          .then((result) => {
            if (result !== 'denied') {
              this.sendNotification();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (Notification.permission === 'granted') {
        this.sendNotification();
      } else {
        // permission is denied
        Notification.requestPermission()
          .then((result) => {
            console.log(result);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  },
};

export default helpers;
